import React, { useState } from "react";
import "./ToolbarSection.scss";

import { ReactComponent as ChevronIcon } from "src/images/chevron-down-alt.svg";
import classNames from "classnames";
import { getReportSettingByKey } from "src/app/ReportGenerator/utils/reportFunctions";

export function ToolbarSection(props) {
  const { children, className, icon, name, tooltip } = props;

  const ids = getReportSettingByKey("ids");

  const [showContent, setShowContent] = useState(false);

  const isCampaignSingle = Boolean(ids.length === 1);

  return (
    <div
      className={classNames(
        "toolbar-section",
        {
          "toolbar-section--single": isCampaignSingle,
        },
        className,
      )}
    >
      <div
        className="toolbar-section__header"
        onClick={() => setShowContent((v) => !v)}
      >
        <span className="toolbar-section__header-data">
          {icon}
          <span className="toolbar-section__header-data-name">{name}</span>
          {tooltip}
        </span>

        {!isCampaignSingle && (
          <ChevronIcon
            className={classNames("arrow", { "arrow--rotated": showContent })}
          />
        )}
      </div>

      {(showContent || isCampaignSingle) && (
        <div className="toolbar-section__content">{children}</div>
      )}
    </div>
  );
}
